module.exports = __webpack_public_path__ + "static/media/Silhouette002.b76f1416.png";